import { Statement } from "@/helpers/Interfaces";
import axios from "axios";

export default class TaskActivityAssignmentsService
{
    public static async getList(taskPublicId: string): Promise<AssignmentListItem[]>
    {
        return (await axios.get<AssignmentListItem[]>(`admin/renters/tasks/${taskPublicId}/activities`)).data;
    }

    public static async add(taskPublicId: string, model: AddAssignmentModel): Promise<AssignmentListItem>
    {
        return (await axios.post<AssignmentListItem>(`admin/renters/tasks/${taskPublicId}/activities`, model)).data;
    }

    public static async updateComment(taskPublicId: string, assignmentPublicId: string, comment: string): Promise<Statement>
    {
        return (await axios.put(`admin/renters/tasks/${taskPublicId}/activities/${assignmentPublicId}`, { comment })).data as Statement;
    }

    public static async remove(taskPublicId: string, assignmentPublicId: string): Promise<Statement>
    {
        return (await axios.delete(`admin/renters/tasks/${taskPublicId}/activities/${assignmentPublicId}`)).data as Statement;
    }
}

export interface AddAssignmentModel {
    activityPublicId: string;
    comment?: string;
}

export interface AssignmentListItem {
    publicId: string;
    activityPublicId: string;
    activityName: string;
    categoryPublicId: string;
    categoryName: string;
    comment: string;
    addedById: number;
    addedAtUtc: string;
    activityIsDeleted: boolean;
}
